export default {
  title: 'Letze 4 Wochen',
  item_interval: '(1)[1 Mal besucht];(2)[2 Mal besucht];(3-5)[3-5 Mal besucht];(6-inf)[6+ Mal besucht];',
  total: 'Gesamtbesuche',
};
